<template>
  <v-container fluid pa-0 ma-0 class="test_red checkout-container pl-3">
    <div class="container-home">
      <v-row no-gutters justify="start">
        <v-icon class="pr-3" v-text="'mdi-clock-outline'" />
        <v-card-subtitle class="pl-0" v-text="openToday" />
        <v-icon color="primary" class="pr-3" v-text="'mdi-information'" />
        <v-card-subtitle
          class="pl-0 p-color text-btn"
          @click="handleClick"
          v-text="$t('discovery.seeMoreInfo')"
        />
        <v-icon
          v-if="showOffer && $vuetify.breakpoint.mdAndUp"
          color="#E3780C"
          class="pr-3"
          v-text="'mdi-tag'"
        />
        <v-card-subtitle
          v-if="showOffer && $vuetify.breakpoint.mdAndUp"
          style="color: #e3780c"
          class="pl-0"
          v-text="message"
        />
      </v-row>
    </div>
    <v-dialog
      v-model="showInfo"
      persistent
      max-width="550"
      :fullscreen="$vuetify.breakpoint.mobile"
      transition="dialog-bottom-transition"
      :content-class="$vuetify.breakpoint.mobile ? '' : 'dialog-rounded'"
      :scrollable="false"
    >
      <StoreInfoDetail v-if="showInfo" v-model="showInfo" />
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment-timezone";
import { StoreInfoDetail } from "@/views/front/discovery/components/index";

export default {
  name: "StoreInfoBar",
  components: {
    StoreInfoDetail,
  },
  data: () => ({
    showInfo: false,
    today: new Date().toISOString().substr(0, 10),
    week: [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ],
  }),
  computed: {
    showOffer: {
      get() {
        if (this.$store.getters.storeInfo.hasOffers !== false) {
          return !this.$store.getters.storeInfo.hasOffers.isCodeRequired;
        } else {
          return false;
        }
      },
      set(val) {
        return val;
      },
    },
    message: {
      get() {
        return this.$t("offers.offer_text", {
          amount:
            this.$store.getters.storeInfo.hasOffers.type === "Amount"
              ? this.$appFormatters.formatMoney(
                  this.$store.getters.storeInfo.hasOffers.amount
                )
              : this.$store.getters.storeInfo.hasOffers.amount + "%",
        });
      },
      set(val) {
        return val;
      },
    },
    openToday: function () {
      let schedule = this.$store.getters.storeInfo.openingHours;
      let found = _.find(schedule, {
        dayName: this.week[moment(new Date(this.today)).add(0, "d").day()],
      });
      if (found.isClosed) {
        return this.$t("general.closed");
      } else {
        return (
          this.$appFormatters.formatTime24(found.open) +
          "-" +
          this.$appFormatters.formatTime24(found.closing)
        );
      }
    },
  },
  methods: {
    handleClick() {
      this.showInfo = true;
      // Call any function or perform any action you want here
    },
  },
};
</script>

<style lang="scss">
.text-btn {
  cursor: pointer;
}
.checkout-container {
  border-bottom: solid !important;
  border-width: 1px !important;
  border-color: rgba($color: #afafaf, $alpha: 0.5) !important;
}
.container-home {
  max-width: 1400px !important;
  margin: 0 auto;
}
.p-color {
  color: var(--v-primary-base) !important;
}
@media screen and (max-width: 960px) {
  .container-home {
    max-width: none !important;
    //padding: 0 30px !important;
  }
}
</style>
